<ng-container *ngIf="!loading">
	<div class="header-padding">
		<div class="header-container">
			<div class="report-info">
				<h2 class="report-title">Blast Performance</h2>
				<p class="report-subtitle">
					<span class="subtitle-span">Fragmentation</span> - Visualize Particle Size Distribution Trend such
					as Fines and Oversize.
				</p>
			</div>
			<div class="export-btn">
				<button mat-button class="export-pdf-btn primary cta" (click)="pdfDownload()">
					<mat-icon class="svg-icon" svgIcon="pdfIcon"></mat-icon>
					Export as PDF
				</button>
			</div>
		</div>
	</div>

	<app-dashboard-chart-group [chartOptions]="chartOptions" [Highcharts]="Highcharts"
		(chartInstance)="onChartInstance($event.chart, $event.index)">
	</app-dashboard-chart-group>
</ng-container>

<ng-container *ngIf="loading">
	<div class="loading-logo">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>